// extracted by mini-css-extract-plugin
export default {"pageGame":"iQ7Y7P","tips":"cjY6b7"};